import styled from 'styled-components';
import { colors } from 'spw-theme';
import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  Paper,
  TextField,
  TextFieldProps,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { SPWMainButton, SPWSaveButton } from 'spw-shared/globalComponents';
import React from 'react';
import { globalInputLabelProps } from 'spw-shared/globalComponents/forms';

export const SaveDownloadDialogTitle = styled.h1`
  && {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 8px 0;
  }
`;

export const SaveDownloadDialogContainer = styled(Paper)`
  background: ${colors.white};
  width: 370px;
  box-sizing: border-box;
  padding: 24px;
`;

export const SaveDownloadDialogDescription = styled.p`
  font-size: 16px;
  line-height: 20px;
  margin-top: 0;
  margin-bottom: 32px;
`;

export const DownloadAfterSavingChangesDialog = withStyles({
  root: {
    '& .MuiPaper-root': {
      minWidth: 385,
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      height: '248px',
    },
  },
})((props: DialogProps) => <Dialog {...props} disableScrollLock />);

export const DownloadButton = styled(SPWSaveButton)`
  && {
    width: 113px;
    margin-right: 16px;
  }
`;

export const DownloadNameInput = withStyles({
  root: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      padding: '10px 12px',
      height: 40,
      boxSizing: 'border-box',
    },
    '& .MuiOutlinedInput-input': {
      padding: 0,
    },
  },
})((props: TextFieldProps) => (
  <TextField
    {...props}
    InputLabelProps={globalInputLabelProps}
    variant="outlined"
  />
));

export const UnsavedChangesDialogTitle = styled(DialogTitle)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    padding-bottom: 6px;
    padding-top: 24px;
    && h2 {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const UnsavedChangesDialogContent = styled(DialogContent)`
  font-size: 16px;
  line-height: 20px;
`;

export const GoBackButton = styled(SPWMainButton)`
  && {
    width: 95px;
    margin-right: 20px;
  }
`;

export const FixedDialogWrapper = styled.div`
  position: fixed;
  top: 128px;
`;
